__turbopack_context__.v({
  "acoBtnActive": "vBgtkW_acoBtnActive",
  "acoBtnInactive": "vBgtkW_acoBtnInactive",
  "acoDropDownWrapper": "vBgtkW_acoDropDownWrapper",
  "acoTitle": "vBgtkW_acoTitle",
  "golfDropdownActive": "vBgtkW_golfDropdownActive",
  "golfDropdownInactive": "vBgtkW_golfDropdownInactive",
  "removeBtn": "vBgtkW_removeBtn",
  "textSelectionButton": "vBgtkW_textSelectionButton",
});
